<template>
  <div id="projectsComponent">
    <page-title :heading=heading :subheading=subheading :icon=icon></page-title>
    <v-container>
      <v-layout class="mb-2" row wrap>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="projectSearch"
          :label="$t('general.search')"
          clearable
          append-outer-icon="search">
        </v-text-field>
          <v-dialog
            persistent
            v-model="dialog"
            max-width="500px"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                color="primary"
                round
                outline
                v-on="on">
                <v-icon left>folder_open</v-icon>
                {{ $t('project.add') }}
              </v-btn>
            </template>
            <v-card>
              <v-toolbar
                flat>
                <h2 class="font-weight-black primary--text mb-0">{{formTitle}}</h2>
              </v-toolbar>
              <v-card-text>
                <v-container grid-list-xs>
                  <v-form
                    lazy-validation
                    ref= "form"
                    v-model="valid">
                    <v-text-field
                      clearable
                      required
                      v-model="editedItem.name"
                      :rules="rules.required"
                      :error-messages="errors.name"
                      :label="$t('general.name')">
                    </v-text-field>
                    <v-text-field
                      v-if="applyFeatures"
                      clearable
                      v-model="editedItem.external_project_id"
                      :label="$t('general.Accountingid')"
                      :rules="rules.charactersMax100">
                    </v-text-field>
                    <v-flex xs12 md12>
                      <v-checkbox
                      color="primary"
                      v-model="bUnit"
                      :label="$t('general.Addbussinessunit')"
                      />
                    </v-flex>
                  <v-flex v-if="bUnit" xs12 md12>
                    <v-text-field
                      clearable
                      v-model="editedItem.business_unit"
                      :label="$t('general.businessUnit')"
                      :rules="rules.characters">
                    </v-text-field>
                  </v-flex>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary darken-1"
                  round
                  flat
                  @click="close">
                  {{ $t('general.cancel') }}
                </v-btn>
                <v-btn
                  :loading="loading"
                  :disabled="loading"
                  color="primary"
                  round
                  depressed
                  @click="save">
                    {{ $t('general.submit') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      </v-layout>
      <b-tabs pills active-nav-item-class="primary">
        <b-tab>
          <template variant="primary" v-slot:title>
            <h5 class="my-0">{{$t('projects.status.active')}}</h5>
          </template>
          <v-flex>
            <v-toolbar flat color="bg-sidebar" dark>
              <h2 class="my-0">{{$t('projects.status.active')}}</h2>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-data-table
              style="width: 100%"
              :search="projectSearch"
              class="elevation-2"
              :headers="headers"
              :items="activeProjects"
              :loading="loadingItems"
              :rows-per-page-items="[10,15,25]"
              :pagination.sync="pagination">
              <template v-slot:headers="props">
                <tr class="bg-heavy-rain">
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                    @click="changeSort(header.value)"
                    >
                    <h2 class="font-weight-black primary--text mb-0">
                      <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                      {{ header.text }}
                    </h2>
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <tr>
                <td class="text-sm-center" style="width: 10%">{{props.item.id}}</td>
                <td class="text-sm-center" style="width: 40%">{{props.item.name}}</td>
                <td class="text-sm-center" style="width: 10%">{{props.item.external_project_id}}</td>
                <td class="text-sm-center" style="width: 10%">{{props.item.business_unit}}</td>
                <td class="text-sm-center" style="width: 30%">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        outline
                        icon
                        color="info"
                        v-on="on"
                        @click="editItem(props.item)">
                        <v-icon small>edit</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('general.edit') }}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        outline
                        icon
                        color="error"
                        v-on="on"
                        @click="deactivated(props.item)">
                        <v-icon small>power_settings_new</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('general.deactivate') }}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        outline
                        icon
                        color="error"
                        v-on="on"
                        @click="removed(props.item)">
                        <v-icon small>delete</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('general.delete') }}</span>
                  </v-tooltip>
                </td>
              </tr>
              </template>
            </v-data-table>
          </v-flex>
        </b-tab>
        <b-tab>
          <template variant="primary" v-slot:title>
            <h5 class="my-0">{{$t('projects.status.inactive')}}</h5>
          </template>
          <v-flex>
            <v-toolbar flat color="bg-sidebar" dark>
              <h2 class="my-0">{{$t('projects.status.inactive')}}</h2>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-data-table
              style="width: 100%"
              :search="projectSearch"
              class="elevation-2"
              :headers="headers"
              :items="inactiveProjects"
              :loading="loadingItems"
              :rows-per-page-items="[10,15,25]"
              :pagination.sync="pagination">
              <template v-slot:headers="props">
                <tr class="bg-heavy-rain">
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                    @click="changeSort(header.value)"
                    >
                    <h2 class="font-weight-black primary--text mb-0">
                      <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                      {{ header.text }}
                    </h2>
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <tr>
                <td class="text-sm-center" style="width: 10%">{{props.item.id}}</td>
                <td class="text-sm-center" style="width: 40%">{{props.item.name}}</td>
                <td class="text-sm-center" style="width: 10%">{{props.item.external_project_id}}</td>
                <td class="text-sm-center" style="width: 10%">{{props.item.business_unit}}</td>
                <td class="text-sm-center" style="width: 30%">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        outline
                        icon
                        color="info"
                        v-on="on"
                        @click="editItem(props.item)">
                        <v-icon small>edit</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('general.edit') }}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        outline
                        icon
                        color="primary"
                        v-on="on"
                        @click="activated(props.item)">
                        <v-icon small>power_settings_new</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('general.activate') }}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        outline
                        icon
                        color="error"
                        v-on="on"
                        @click="removed(props.item)">
                        <v-icon small>delete</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('general.delete') }}</span>
                  </v-tooltip>
                </td>
              </tr>
              </template>
            </v-data-table>
          </v-flex>
        </b-tab>
      </b-tabs>
      <v-dialog
        persistent
        v-model="removeDialog"
        max-width="500px"
      >
        <v-card>
          <v-toolbar
            flat
          >
            <h2 class="font-weight-black error--text mb-0">{{ $t('project.delete') }}</h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('general.deleteElementQuestion') }}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="removeDialog = false"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="error"
              round
              depressed
              @click="deleteItem(removedItem)"
            >
              {{ $t('general.delete') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        persistent
        v-model="deactivateDialog"
        max-width="500px"
      >
        <v-card>
          <v-toolbar
            flat
          >
            <h2 class="font-weight-black error--text mb-0">{{ $t('project.deactivate') }}</h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('general.deactivateElementQuestion') }}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="deactivateDialog = false"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="error"
              round
              depressed
              @click="deactivateItem(deactivatedItem)"
            >
              {{ $t('general.deactivate') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        persistent
        v-model="activateDialog"
        max-width="500px"
      >
        <v-card>
          <v-toolbar
            flat
          >
            <h2 class="font-weight-black error--text mb-0">{{ $t('project.activate') }}</h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('general.activateElementQuestion') }}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="activateDialog = false"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="error"
              round
              depressed
              @click="activateItem(activatedItem)"
            >
              {{ $t('general.activate') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
export default {
  name: 'projectsComponent',
  data () {
    return {
      bUnit: false,
      projectSearch: '',
      dialog: false,
      removeDialog: false,
      deactivateDialog: false,
      activateDialog: false,
      editedIndex: -1,
      loading: false,
      loadingItems: true,
      valid: true,
      removedItem: {},
      deactivatedItem: {},
      activateditem: {},
      editedItem: {
        name: '',
        external_project_id: '',
        business_unit: '',
        company_id: 0,
        status: 1
      },
      defaultItem: {
        name: '',
        external_project_id: '',
        business_unit: '',
        company_id: 0,
        status: 1
      },
      projects: [],
      inactiveProjects: [],
      userLogged: {
        roles: [
          {
            id: null
          }
        ],
        company: [
          {
            id: null
          }
        ]
      },
      project: null,
      company: null,
      error: false,
      errorMessage: '',
      errors: {},
      pagination: {
        sortBy: 'name',
        descending: false,
        page: 1,
        rowsPerPage: 15, // -1 for All",
        totalItems: 0
      }
    }
  },
  computed: {
    applyFeatures () {
      if (this.$store.state.userLogged.company === undefined) {
        return false
      }

      if (this.$store.state.userLogged.company[0].features.find(x => x.name === 'CATALOG_EXTRA_FIELDS_FREY')) {
        return true
      }

      return false
    },
    activeProjects () {
      let active = []
      active = this.projects.filter(x => x.status === 1)
      return active
    },
    heading () {
      return this.$t('general.projects')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'far fa-folder-open fa-fw icon-color'
    },
    formTitle () {
      return this.editedIndex === -1 ? this.$t('project.add') : this.$t('project.edit')
    },
    editingItem () {
      return this.editedIndex !== -1
    },
    isNewItem () {
      return this.editedIndex === -1
    },
    rules () {
      return this.$validationRules()
    },
    headers () {
      return [
        {
          text: '#',
          align: 'center',
          value: 'id',
          sortable: true
        },
        {
          text: this.$t('general.project'),
          align: 'center',
          value: 'name',
          sortable: true
        },
        {
          text: this.$t('general.Accountingid'),
          align: 'center',
          value: 'Accountingid',
          sortable: true
        },
        {
          text: this.$t('general.businessUnit'),
          align: 'center',
          value: 'businessUnit',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false
        }
      ]
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    userLogged () {
      this.$emit('getProjects', { id: this.userLogged.company[0].id, context: this })
      this.$emit('getInactiveProjects', { id: this.userLogged.company[0].id, context: this })
    },
    '$store.state.userLogged' () {
      this.getLogged()
    }
  },
  created () {
    this.initialize()
  },
  methods: {
    getLogged () {
      if (this.$store.state.userLogged.company) {
        this.userLogged = this.$store.state.userLogged
      }
    },
    changeSort (header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    removed (item) {
      this.removedItem = item
      this.removeDialog = true
    },
    deactivated (item) {
      this.deactivatedItem = item
      this.deactivateDialog = true
    },
    activated (item) {
      this.activatedItem = item
      this.activateDialog = true
    },
    deleteItem (item) {
      this.loading = true
      const index = this.projects.indexOf(item)
      this.delete(item, index)
      // this.removeDialog = false
    },
    deactivateItem (item) {
      this.loading = true
      const index = this.projects.indexOf(item)
      this.deactivate(item, index)
    },
    activateItem (item) {
      this.loading = true
      const index = this.inactiveProjects.indexOf(item)
      this.activate(item, index)
    },
    close () {
      this.dialog = false
      this.loading = false
      this.errors = {}
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.$refs.form.resetValidation()
      this.bUnit = false
    },
    editItem (item) {
      this.bUnit = !!item.business_unit
      this.editedIndex = this.projects.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    save () {
      this.loading = true
      if (this.editedIndex > -1) {
        this.put()
      } else {
        this.post()
      }
    },
    post () {
      this.$emit('postProjects', { name: this.editedItem.name, business_unit: this.editedItem.business_unit, external_project_id: this.editedItem.external_project_id, company: this.userLogged.company[0].id, context: this })
    },
    put () {
      this.$emit('putProjects', { item: this.editedItem, index: this.editedIndex, context: this })
    },
    delete (item, index) {
      this.$emit('deleteProjects', { item: item, index: index, context: this })
    },
    deactivate (item, index) {
      this.$emit('deactivateProjects', { item: item, index: index, context: this })
    },
    activate (item, index) {
      this.$emit('activateProjects', { item: item, index: index, context: this })
    },
    initialize () {
      // this.$emit('getLogged', { context: this })
      this.getLogged()
      this.$emit('companyGet', {context: this})
    },
    refresh () {
      this.$emit('refresh', {
        context: this
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/projects.component.vue